export interface DomainConfig {
  domain: string;
  language: string;
  clarityId?: string;
  zadarmaWidgetId?: string;
  region: string;
  name: string;
}

export const DOMAIN_CONFIG: Record<string, DomainConfig> = {
  // Локальні домени для розробки
  localhost: {
    domain: "localhost",
    language: "de",
    region: "DE",
    name: "Development",
  },
  "localhost:3000": {
    domain: "localhost:3000",
    language: "de",
    region: "DE",
    name: "Development",
  },
  "localhost:5173": {
    domain: "localhost:5173",
    language: "de",
    region: "DE",
    name: "Development (DE)",
  },
  // Порти для різних мов (розробка)
  "localhost:5174": {
    domain: "localhost:5174",
    language: "ua",
    region: "UA",
    name: "Development (UA)",
    zadarmaWidgetId: "d6e83b55152602eddbcc7809137db124",
  },
  "localhost:5175": {
    domain: "localhost:5175",
    language: "pl",
    region: "PL",
    name: "Development (PL)",
  },
  "localhost:5176": {
    domain: "localhost:5176",
    language: "cz",
    region: "CZ",
    name: "Development (CZ)",
  },

  // Реальні домени
  "hixa.eu": {
    domain: "hixa.eu",
    language: "de",
    region: "DE",
    name: "Deutschland",
    clarityId: "ufbdiwlrqv",
  },
  "poland.hixa.eu": {
    domain: "poland.hixa.eu",
    language: "pl",
    region: "PL",
    name: "Polska",
    clarityId: "uo1oj2tsrd",
  },
  "ukraine.hixa.eu": {
    domain: "ukraine.hixa.eu",
    language: "ua",
    region: "UA",
    name: "Україна",
    clarityId: "uo1m16uwqu",
    zadarmaWidgetId: "d6e83b55152602eddbcc7809137db124",
  },
  "czechia.hixa.eu": {
    domain: "czechia.hixa.eu",
    language: "cz",
    region: "CZ",
    name: "Česko",
    clarityId: "uo6kkcbglk",
  },
};

export const SUPPORTED_LANGUAGES = ["de", "pl", "ua", "cz"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  de: "Deutsch",
  pl: "Polski",
  ua: "Українська",
  cz: "Čeština",
};

export const getDomainConfig = (): DomainConfig => {
  const hostname =
    window.location.hostname +
    (window.location.port ? ":" + window.location.port : "");

  return DOMAIN_CONFIG[hostname] || DOMAIN_CONFIG["localhost"];
};

export const getCurrentLanguage = (): SupportedLanguage => {
  return getDomainConfig().language as SupportedLanguage;
};

export const getCurrentDomain = (): string => {
  return getDomainConfig().domain;
};
